<template>
  <div class="solfigrf-form solfigrfmr">
    <SolfigrGmfShortcut
      :gameformat="gameformat"
      :namespace="namespace"
      :instaApply="instaApply"
      :shortcut="shortcut"
      @click:apply="handleApply"
      @update:shortcut="handleUpdateShortcut"
    >
      <div class="f-column">
        <GwTitleTooltip
          class="solfigrranges_title"
          :title="$t('common.solutions')"
          style="margin: 0 0 0.25rem 0"
        />
        <GmfSelektorBtn
          :gmfHtml="gmf.mainHtml"
          data-tst="solfigr_shortcut_gmfselektorbtn"
          @click="openSolutionsDialog"
        />
      </div>
    </SolfigrGmfShortcut>
  </div>
</template>

<script>
import GmfSelektorBtn from '@/components/GameFormat/GmfSelektor/GmfSelektorBtn'
import GwTitleTooltip from '@/components/Dialogs/UserSettingsDialog/GwTitleTooltip'
import { getGameformatOptionHtml } from '@/store/gameformat/gameformat'
import SolfigrGmfShortcut from '@/components/ConfigureSolution/SolfigrGmfShortcut'

import float_mix from '@/mixins/float_mix'

export default {
  name: 'SolfigrGmfForm',

  components: {
    SolfigrGmfShortcut,
    GmfSelektorBtn,
    GwTitleTooltip,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    gameformat: Object,
    shortcut: Object,
    instaApply: Boolean,
  }, 
 emits: ['click:apply','update:shortcut'],
  data() {
    this.tmpNamespace = 'tmp/extra3'
    return {}
  },
  methods: {
    handleApply() {
      this.$emit('click:apply')
    },
    handleUpdateShortcut(shortcut) {
      this.$emit('update:shortcut', shortcut)
    },
    openSolutionsDialog() {
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.namespace,
        to_namespace: this.tmpNamespace,
        queryGroup: 'router',
      })
      this.$store.dispatch('poker_copy_module', {
        from_namespace: this.tmpNamespace,
        to_namespace: this.tmpNamespace,
        queryGroup: 'router-to-gmf-selektor',
      })
      const dialog = `solutions-dialog_applyMode-solfigrprefill_namespace-${this.namespace}_tmpNamespace-${this.tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
  },
  computed: {
    gmf() {
      const mainHtml = getGameformatOptionHtml({
        gameformat: this.gameformat,
      })
      const res = {
        mainHtml,
      }
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.solfigrfmr {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
